import React from 'react';
import { Grid, Typography } from '@mui/material';
import { IPointOfIntrestSectionProps } from 'app/models/Orders/OrderDetails';
import { useStyles } from './OrderDetailsReportStyles';
import { useTranslation } from 'react-i18next';

interface PointOfIntrestSectionProps {
  poiDetails: IPointOfIntrestSectionProps;
}
export const OrderDetailsReportPointOfInterest = (props: PointOfIntrestSectionProps) => {
  const { classes } = useStyles();
  const poiDetails = props.poiDetails;
  const { t } = useTranslation();
  return (
    <Grid container sx={theme => ({ paddingBottom: theme.spacing(4) })}>
      <Grid container>
        <Grid xs={6} md={2} className={`${classes.labelCell}`}>
          <Typography>{t('order.orderReportDetails.poiSection.demographics')}:</Typography>
        </Grid>
        <Grid xs={6} md={10} className={`${classes.dataCell}`}>
          {poiDetails.demographics?.split('\n').length > 1
            ? poiDetails.demographics?.split('\n').map(str => <Typography>{str}</Typography>)
            : poiDetails.demographics}

        </Grid>
      </Grid>

      <Grid container>
        <Grid xs={6} md={2} className={`${classes.alternativeLabelCell}`}>
          <Typography>{t('order.orderReportDetails.poiSection.facilityhighlights')}:</Typography>
        </Grid>
        <Grid xs={6} md={10} className={`${classes.alternativeDataCell}`}>
          {poiDetails.facilityHighlights?.split('\n').length > 1
            ? poiDetails.facilityHighlights?.split('\n').map(str => <Typography>{str}</Typography>)
            : poiDetails.facilityHighlights}
        </Grid>
      </Grid>
    </Grid>
  );
};
